<nav class="navbar navbar-expand-lg">
    <div class="container">
        <a class="navbar-brand" href="#">
            <img src="assets/images/Blockchain_Logo_Black.png" alt="BX Logo">
        </a>
        <div class="dropdown btn-section">
            <w3m-button balance='hide'></w3m-button>
        </div>
    </div>
</nav>
